import { showHttpError, showSuccess } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'

import { setOrganization } from 'common'

const processUpdateResult = (dispatch, [success, response]) => {
  if (success) {
    dispatch(showSuccess(I18n.t('publisher.flash.settings_saved')))
    dispatch(setOrganization(response))
  } else {
    dispatch(showHttpError(response))
  }
}

export const saveOrgEventTypeSettings = (settings) => async (dispatch) => {
  const result = await httpRequest({
    url: '/api/organization/shared_event_type_settings',
    method: 'PUT',
    params: { settings }
  })

  processUpdateResult(dispatch, result)
}

export const saveOrgWorkflowsSettings = (settings) => async (dispatch) => {
  const result = await httpRequest({
    url: '/api/organization/workflows_settings',
    method: 'PUT',
    params: { settings }
  })

  processUpdateResult(dispatch, result)
}

export const saveOrgInvitationPermissionsSettings = (settings) => async (dispatch) => {
  const result = await httpRequest({
    url: '/api/organization/invitation_permissions',
    method: 'PUT',
    params: { invitation_permissions_role: settings.invitation_permissions_enabled_for }
  })

  processUpdateResult(dispatch, result)
}

export const saveOrgVisibilitySettings = (settings) => async (dispatch) => {
  const result = await httpRequest({
    url: '/api/organization/visibility_settings',
    method: 'PUT',
    params: { settings }
  })

  processUpdateResult(dispatch, result)
}
